import {z} from 'zod';

const PhoneNumberSchema = z.object({
  countryCode: z.string(),
  number: z.string(),
  prefix: z.string(),
});

const DriverSchema = z.object({
  id: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  phoneNumber: PhoneNumberSchema.nullable().optional(),
  email: z.string().nullable().optional(),
  identityCard: z.string().nullable().optional(),
});

const ServiceCheckInCommonSchema = z.object({
  serviceCheckinId: z.string().nullable().optional(),
  state: z.enum(['SCHEDULED', 'COMPLETED']).nullable().optional(),
  scheduledDate: z.string().nullable().optional(),
  completedDate: z.string().nullable().optional(),
  driver: DriverSchema.nullable().optional(),
  consentToTestDrive: z.boolean().nullable().optional(),
  mileage: z.number().nullable().optional(),
  fuelTank: z.number().nullable().optional(),
  technicalInspection: z.string().nullable().optional(),
  emissions: z.string().nullable().optional(),
  note: z.string().nullable().optional(),
  isVehicleNotInService: z.boolean().nullable().optional(),
  isNonDrivableVehicle: z.boolean().nullable().optional(),
  inspectionId: z.array(z.string()).nullable().optional(),
});

export const GetServiceCheckInApiResponseSchema = ServiceCheckInCommonSchema.nullable();

export type GetServiceCheckInApiResponse = z.infer<typeof GetServiceCheckInApiResponseSchema>;

export const GetServiceCheckInApiArgSchema = z.object({
  serviceCaseId: z.string(),
});

export type GetServiceCheckInApiArg = z.infer<typeof GetServiceCheckInApiArgSchema>;

const CheckinCreateEditResponse = z
  .object({
    isMileageValid: z.boolean(),
    highestMileage: z.number().nullable().optional(),
  })
  .nullable();

export const PostServiceCheckInApiResponseSchema = CheckinCreateEditResponse;
export type PostServiceCheckInApiResponse = z.infer<typeof PostServiceCheckInApiResponseSchema>;

const PostServiceCheckInBodySchema = ServiceCheckInCommonSchema.extend({
  withFuelTankMileageUpdate: z.boolean().nullable().optional(),
}).omit({
  serviceCheckinId: true,
});

export const PostServiceCheckInApiArgSchema = z.object({
  serviceCaseId: z.string(),
  body: PostServiceCheckInBodySchema.nullable(),
});

export type PostServiceCheckInApiArg = z.infer<typeof PostServiceCheckInApiArgSchema>;

export const PatchServiceCheckInApiResponseSchema = CheckinCreateEditResponse;
export type PatchServiceCheckInApiResponse = z.infer<typeof PatchServiceCheckInApiResponseSchema>;

const PatchServiceCheckInBodySchema = PostServiceCheckInBodySchema;

export const PatchServiceCheckInApiArgSchema = z.object({
  serviceCaseId: z.string(),
  body: PatchServiceCheckInBodySchema.nullable(),
});

export type PatchServiceCheckInApiArg = z.infer<typeof PatchServiceCheckInApiArgSchema>;

export const GetServiceCheckInDefaultDriverApiApiResponseSchema = z.object({
  driverEmail: z.string().nullable().optional(),
  driverFirstname: z.string().nullable().optional(),
  driverIdentityCard: z.string().nullable().optional(),
  driverLastname: z.string().nullable().optional(),
  driverPhoneNo: z.string().nullable().optional(),
  driverPhonePrefix: z.string().nullable().optional(),
  driverPhoneCountryCode: z.string().nullable().optional(),
});

export type GetServiceCheckInDefaultDriverApiApiResponse = z.infer<
  typeof GetServiceCheckInDefaultDriverApiApiResponseSchema
>;

export const GetServiceCheckInDefaultDriverApiApiArgSchema = z.object({
  serviceCaseId: z.string(),
});

export type GetServiceCheckInDefaultDriverApiApiArg = z.infer<
  typeof GetServiceCheckInDefaultDriverApiApiArgSchema
>;

export {DriverSchema};
export type DriverType = z.infer<typeof DriverSchema>;
export {PhoneNumberSchema};
export type PhoneNumberType = z.infer<typeof PhoneNumberSchema>;
